'use client'
import { ScrollableContainer } from '@/components/layout/scrollable-container'
import { CardHeader } from '@/components/ui/card-header'
import { CardWrapper } from '@/components/ui/card-wrapper'
import { NewScrollCards } from '@/components/ui/new-scroll-cards'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import { TCardData } from '../data/cards'

interface IScrollCardProps {
  cardData: TCardData[]
}

export function HomeCards({ cardData }: IScrollCardProps) {
  const t = useTranslations('Home')

  return (
    <ScrollableContainer>
      <NewScrollCards
        height="520px"
        gap="64px"
        className="mb-32 md:mb-30"
        numCards={cardData.length}
      >
        {cardData.map((card, index) => (
          <div
            key={index}
            className={cn(
              'rounded-3xl text-center md:rounded-[48px] md:text-left',
              card.bgColor,
              card.textColor
            )}
          >
            <CardWrapper className="pb-4 md:pb-8">
              <CardHeader
                title={t(card.title)}
                content={t(card.content)}
                button={{
                  buttonText: t(card.buttonText),
                  buttonVariant: card.buttonVariant,
                  buttonTextColor: card.buttonTextColor,
                  href: card.href || '#'
                }}
              />

              <Image
                src={card.image}
                alt={t(card.title)}
                width={400}
                height={260}
                className="w-full max-w-160"
              />
            </CardWrapper>
          </div>
        ))}
      </NewScrollCards>
    </ScrollableContainer>
  )
}
